import axios from "axios";
import { setLicenceValidity } from "../reducers/licence";
import { store } from "../ProviderApp";
import { getBackendUrl } from "@Utils";
import { createAxiosWrapper, PlatformAdapter, ApiResponse } from "./axiosShared";

const webAdapter: PlatformAdapter = {
  storage: {
    getItem: (key) => localStorage.getItem(key),
    removeItem: (key) => localStorage.removeItem(key),
  },
  navigation: {
    getCurrentPath: () => window.location.pathname,
    redirectToLogin: (params) => {
      const searchParams = new URLSearchParams();
      if (params?.redirectUrl) {
        searchParams.set("redirectUrl", encodeURIComponent(params.redirectUrl + window.location.search));
      }
      if (params?.errorMessage) {
        searchParams.set("errorMessage", encodeURIComponent(params.errorMessage));
      }
      window.location.href = `/?${searchParams.toString()}${window.location.hash}`;
    },
  },
  dispatch: (action) => store.dispatch(action as any),
  actions: {
    setLoggedOut: () => ({ type: "LOGOUT" }),
    setLicenceInvalid: () => setLicenceValidity(false),
  },
  excludedPathsFor401: ["/googleLoginCallback", "/95789", "/signup", "/thank-you", "/pdfExport", "/"],
  getBackendUrl: () => getBackendUrl() as string,
};

const { typedAxios } = createAxiosWrapper(webAdapter, axios);

export type { ApiResponse };
export { typedAxios };
export const axiosWrapper = typedAxios;
export default typedAxios;
